/* eslint-disable */
import React from "react";
import { Card, Title, Text, Divider } from "@mantine/core";

export default function ChildrensPrivacyCard() {
  return (
    <Card shadow="sm" radius="md" withBorder>
      <Title order={3}>Children's Privacy</Title>
      <Divider my="md" />
      <Text>
        Our Service does not address anyone under the age of 13. We do not
        knowingly collect personally identifiable information from anyone under
        the age of 13. If You are a parent or guardian and You are aware that
        Your child has provided Us with Personal Data, please contact Us. If We
        become aware that We have collected Personal Data from anyone under the
        age of 13 without verification of parental consent, We take steps to
        remove that information from Our servers.
      </Text>

      <Text mt="sm">
        If We need to rely on consent as a legal basis for processing Your
        information and Your country requires consent from a parent, We may
        require Your parent's consent before We collect and use that
        information.
      </Text>
    </Card>
  );
}
